import React from 'react';
import { Link, useParams } from 'react-router-dom';
import { groupedBySlot, Slot } from './manifest';

const SLOT_LABELS: Record<Slot, string> = {
  Overview: 'Overview',
  Banner: 'Banner',
  Leaderboard: 'Leaderboard',
  SubmissionForm: 'Submission Form',
  SubmissionDetails: 'Submission Details',
};

export default function Sidebar() {
  const params = useParams<{ slot?: string; pattern?: string }>();
  const grouped = groupedBySlot();

  return (
    <nav style={{
      width: 280, borderRight: '1px solid #e2e8f0', padding: '1rem',
      overflowY: 'auto', height: '100vh', boxSizing: 'border-box',
      fontFamily: 'system-ui, sans-serif', fontSize: 14, background: '#fafafa',
    }}>
      <h2 style={{ marginTop: 0, marginBottom: '1rem' }}>Components</h2>
      {(Object.keys(grouped) as Slot[]).map((s) => (
        <div key={s} style={{ marginBottom: '1.25rem' }}>
          <div style={{ fontWeight: 600, color: '#2d3748', marginBottom: '0.5rem', textTransform: 'uppercase', fontSize: 12, letterSpacing: '0.05em' }}>
            {SLOT_LABELS[s]}
          </div>
          <ul style={{ listStyle: 'none', padding: 0, margin: 0 }}>
            {grouped[s].map((entry) => {
              const slotKey = entry.slot.toLowerCase();
              const isActive =
                slotKey === (params.slot || '').toLowerCase() &&
                entry.pattern === params.pattern;
              return (
                <li key={entry.pattern} style={{ marginBottom: '0.25rem' }}>
                  <Link
                    to={`/admin/components/explorer/${slotKey}/${entry.pattern}`}
                    style={{
                      display: 'block', padding: '0.35rem 0.5rem', borderRadius: 4,
                      textDecoration: 'none',
                      background: isActive ? '#edf2f7' : 'transparent',
                      color: isActive ? '#1a202c' : '#4a5568',
                      fontWeight: isActive ? 600 : 400,
                    }}
                  >
                    {entry.pattern.replace(/^\d{2}_/, '').replace(/([A-Z])/g, ' $1').trim()}
                  </Link>
                </li>
              );
            })}
          </ul>
        </div>
      ))}
      <div style={{ marginTop: '2rem', paddingTop: '1rem', borderTop: '1px solid #e2e8f0' }}>
        <Link
          to="/admin/components/explorer/sandbox"
          style={{
            display: 'block', padding: '0.5rem', borderRadius: 4,
            background: (params.slot === 'sandbox') ? '#fef3c7' : '#fffbeb',
            color: '#744210', textDecoration: 'none', fontWeight: 600,
          }}
        >
          Paste your own code →
        </Link>
      </div>
    </nav>
  );
}
